import { render, staticRenderFns } from "./BudgetVizTab.vue?vue&type=template&id=106f36c0&scoped=true"
import script from "./BudgetVizTab.vue?vue&type=script&lang=js"
export * from "./BudgetVizTab.vue?vue&type=script&lang=js"
import style0 from "./BudgetVizTab.vue?vue&type=style&index=0&id=106f36c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f36c0",
  null
  
)

export default component.exports